export const fullEditLevel = "full"
export const managerEditLevel = "manager"
export const fullAndManagerEditLevel = "full_and_manager"
